import { CUSTOMER_JOURNEY_RESERVATION_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_RESERVATION_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyReservationError.js